import { POSTS } from "./blog/posts.ts";
import { CITY_SLUGS } from "./locations/cities.ts";
import { PRODUCT_KEYS } from "./locations/products.ts";

export interface RouteMeta {
  path: string;
  changefreq: "daily" | "weekly" | "monthly" | "yearly";
  priority: number;
  lastmod?: string;
}

export const STATIC_ROUTES: RouteMeta[] = [
  { path: "/", changefreq: "weekly", priority: 1.0 },
  { path: "/about/", changefreq: "monthly", priority: 0.7 },
  { path: "/contact/", changefreq: "monthly", priority: 0.8 },
  { path: "/services/axle-repair/", changefreq: "monthly", priority: 0.9 },
  { path: "/services/emergency-same-day-trailer-repair/", changefreq: "monthly", priority: 0.9 },
  { path: "/reviews/", changefreq: "weekly", priority: 0.8 },
  { path: "/trailer-axle-replacement-cost/", changefreq: "monthly", priority: 0.85 },
  { path: "/free-51-point-inspection/", changefreq: "monthly", priority: 0.85 },
  { path: "/products/", changefreq: "weekly", priority: 0.9 },
  { path: "/products/hubs/", changefreq: "monthly", priority: 0.8 },
  { path: "/products/suspension-parts/", changefreq: "monthly", priority: 0.8 },
  { path: "/products/jacks-couplers/", changefreq: "monthly", priority: 0.8 },
  { path: "/products/tires-wheels/", changefreq: "monthly", priority: 0.8 },
  { path: "/dexter/", changefreq: "monthly", priority: 0.8 },
  { path: "/axle-order-forms/", changefreq: "monthly", priority: 0.8 },
  { path: "/rebates/", changefreq: "weekly", priority: 0.7 },
  { path: "/rebates/axle-rebate/", changefreq: "weekly", priority: 0.85 },
  { path: "/blog/", changefreq: "weekly", priority: 0.8 },
  { path: "/locations/", changefreq: "monthly", priority: 0.8 },
];

export const BLOG_SLUGS: string[] = POSTS.map((p) => p.slug);

// Prerendered but kept out of sitemap.xml (noindex pages like the private
// event invite).
export const UNLISTED_ROUTES: RouteMeta[] = [
  { path: "/invite/", changefreq: "monthly", priority: 0.1 },
  { path: "/es/invite/", changefreq: "monthly", priority: 0.1 },
];

export const ENGLISH_ROUTES: RouteMeta[] = [
  ...STATIC_ROUTES,
  ...CITY_SLUGS.map((slug) => ({
    path: `/locations/${slug}/`,
    changefreq: "monthly" as const,
    priority: 0.75,
  })),
  ...CITY_SLUGS.flatMap((slug) =>
    PRODUCT_KEYS.map((p) => ({
      path: `/locations/${slug}/${p}/`,
      changefreq: "monthly" as const,
      priority: 0.7,
    })),
  ),
  ...BLOG_SLUGS.map((slug) => ({
    path: `/blog/${slug}/`,
    changefreq: "monthly" as const,
    priority: 0.6,
  })),
];

export const ALL_ROUTES: RouteMeta[] = [
  ...ENGLISH_ROUTES,
  ...ENGLISH_ROUTES.map((route) => ({ ...route, path: `/es${route.path}` })),
];

export const SITE_URL = "https://axleinc.com";
export const SITE_NAME = "Axle Inc.";
export const SITE_PHONE = "+15742649434";
export const SITE_PHONE_DISPLAY = "(574) 264-9434";
export const SITE_EMAIL = "info@axleinc.com";
export const SITE_CITY = "Elkhart";
export const SITE_STATE = "IN";
export const SITE_STREET = "53664 Co Rd 9";
export const SITE_POSTAL_CODE = "46514";
export const SITE_COUNTRY = "United States";
export const SITE_ADDRESS_DISPLAY = "53664 Co Rd 9, Elkhart, IN 46514";
export const SITE_MAP_URL = "https://share.google/RP1EhD7dsaQOmtK9z";
export const SITE_MAP_EMBED_QUERY = "53664+Co+Rd+9%2C+Elkhart%2C+IN+46514";
